var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_12033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8046 15.3619L11.8253 11.3825C12.9097 10.0563 13.4429 8.36392 13.3145 6.65556C13.1862 4.94721 12.4061 3.35354 11.1357 2.2042C9.86528 1.05486 8.2017 0.437783 6.48907 0.480604C4.77644 0.523425 3.14578 1.22287 1.93439 2.43426C0.722992 3.64566 0.0235473 5.27632 -0.0192739 6.98895C-0.0620951 8.70158 0.554984 10.3652 1.70432 11.6356C2.85366 12.906 4.44733 13.6861 6.15568 13.8144C7.86404 13.9428 9.55637 13.4096 10.8826 12.3252L14.862 16.3045C14.9877 16.426 15.1561 16.4932 15.3309 16.4916C15.5057 16.4901 15.6729 16.42 15.7965 16.2964C15.9201 16.1728 15.9902 16.0056 15.9918 15.8308C15.9933 15.656 15.9261 15.4876 15.8046 15.3619ZM6.66664 12.4999C5.61181 12.4999 4.58066 12.1871 3.7036 11.601C2.82654 11.015 2.14295 10.182 1.73929 9.2075C1.33562 8.23296 1.23 7.1606 1.43579 6.12604C1.64158 5.09147 2.14953 4.14117 2.89541 3.39529C3.64129 2.64941 4.5916 2.14145 5.62616 1.93567C6.66073 1.72988 7.73308 1.8355 8.70762 2.23916C9.68216 2.64283 10.5151 3.32642 11.1011 4.20348C11.6872 5.08054 12 6.11169 12 7.16652C11.9984 8.58052 11.436 9.93615 10.4361 10.936C9.43628 11.9359 8.08064 12.4983 6.66664 12.4999Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_12033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5974d7bd8a2c7be2dd2b0770165126f3.svg";
export { ForwardRef as ReactComponent };